import { format, parseISO } from "date-fns"

function cfl(word) {
  return word.charAt(0).toUpperCase() + word.slice(1)
}

function ellipsis(value, limit) {
  value = String(value)
  if (typeof value === "string" && value.length > limit) {
    value = `${value.slice(0, limit)}...`
  }

  return value
}

function camelToSnakeCaseWithNumbers(camelStr) {
  return camelStr
    .replace(/([a-z])([A-Z])/g, "$1_$2") // Convert camelCase to snake_case
    .replace(/([a-z])(\d)/gi, "$1_$2") // Add underscore before numbers
    .toLowerCase()
}

function formatLocalDateTime(dateString) {
  if (!dateString)
    return "N/A"

  try {
    const date = parseISO(dateString)
    return format(date, "yyyy-MM-dd HH:mm:ss (O)")
  }
  catch {
    return "N/A"
  }
}

export { camelToSnakeCaseWithNumbers, cfl, ellipsis, formatLocalDateTime }
